<template>
  <v-menu offset-x min-width="180px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" icon color="#1876D2" data-cy="menu-actions-btn">
        <v-icon size="22" color="#41916b">mdi-cog</v-icon>
      </v-btn>
    </template>

    <v-card class="card__menu">
      <div class="card__header">
        <span>MENU DE AÇÕES</span>
      </div>

      <div class="menu__actions" v-if="!resource.deleted_at">
        <div 
          class="action"
          v-for="action in actionsData"
          :key="action.name"
          :data-cy="`menu-action-${action.name.toLowerCase()}`"
          @click="setAction(true, action.type, resource, action.componentName)"
        >
          <div class="indicator"></div>
          <span>
            {{ action.name }}
          </span>
        </div>
      </div>

      <slot></slot>
    </v-card>
  </v-menu>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "MenuGridComponent",

  props: {
    resource: {
      type: Object,
    },
  },

  computed: {
    // recebe as ações enviadas no changeActions
    ...mapGetters({
      actionsData: "getActionsData",
    }),
  },

  watch:{},

  methods: {
    ...mapActions(["changeDefaultModalInfos", "changeIndicatorFormEdit"]),

    setAction(status, type, data, componentName) {

      if (type === "modal") {
        this.$emit("editItemGrid", data);
        this.changeDefaultModalInfos({ status, type, data, componentName });
      } else if (type === "page") {
        const position = this.$router.history.current.path == "/perfis" ? 1 : 2;
        this.$router.push({
          path: this.actionsData[position].route,
          query: { item: data },
        });
      } else if (type === "linkModal") {
        this.$emit("openLinkModal");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.card__menu {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 25px 10px;

  .card__header {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 0 10px 0;

    span {
      font-weight: 600;
      font-size: 10px;
    }
  }

  .menu__actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;

    .action {
      display: flex;
      width: 100%;
      align-items: center;
      margin: 3px 0;
      padding: 10px 0 10px 10px;
      border-radius: 10px !important;
      background: #e4eee6;

      .indicator {
        height: 20px;
        width: 4px;
        background: rgb(76, 107, 76);
        border-radius: 10px;

        margin: 0 8px 0 0;
      }

      span {
        font-size: 14px;
        font-weight: 500;
      }
    }

    .action:hover {
      background: #d1e9d5;
      cursor: pointer;

      .indicator {
        background: gray;
      }

      span {
        color: rgb(34, 34, 34);
      }
    }
  }
}
</style>
